import * as yup from "yup";

const masterNameSchema = (fieldLabel) =>
  yup
    .string()
    .trim()
    .required(`${fieldLabel} is required`);

export const scheduleTypeSchema = yup.object({
  type_name: masterNameSchema("Type name"),
  status_id: yup
    .string()
    .oneOf(["0", "1"], "Select Active or Inactive")
    .required("Status is required"),
});

export const scheduleStatusSchema = yup.object({
  status_name: masterNameSchema("Status name"),
  status_id: yup
    .string()
    .oneOf(["0", "1"], "Select Active or Inactive")
    .required("Status is required"),
});

export const priorityTypeSchema = yup.object({
  priority_name: masterNameSchema("Priority name"),
  status_id: yup
    .string()
    .oneOf(["0", "1"], "Select Active or Inactive")
    .required("Status is required"),
});

export const scheduleTypeFormDefaults = { type_name: "", status_id: "1" };
export const scheduleStatusFormDefaults = { status_name: "", status_id: "1" };
export const priorityTypeFormDefaults = { priority_name: "", status_id: "1" };
